import { Ieducation } from './../Models/ieducation';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';
import { Iprofessional } from '../Models/Iprofessional';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private education =  {} as Ieducation;
  private educationData = new BehaviorSubject(this.education);
  shareEducation = this.educationData.asObservable();

  private experience = {} as Iprofessional;
  private professionalData = new BehaviorSubject(this.experience);
  shareExperience = this.professionalData.asObservable();

  addEducation(edu: Ieducation){
    this.educationData.next(edu);
  }

  addExperience(exp: Iprofessional){
    this.professionalData.next(exp);
  }
  constructor(private toaster: ToastrService) { }

  changeTestFinishedStatus(value: boolean) {
    localStorage.setItem('isFinished',  value.toString());
  }
  getStatus(): boolean {
    return localStorage.getItem('isFinished') === 'true' ? true : false;
  }
clearFinishedStatus() {
    localStorage.clear();
  }
  onSuccess(message: string) {
    this.toaster.success(message, '', {
      positionClass: 'toast-top-right',
      progressBar: true
    });
  }
  onError(mesage: string) {
    this.toaster.error(mesage, '' , {
      positionClass: 'toast-top-right',
      progressBar: true
    });
  }
  onErrorButtomCFullWidth(mesage: string) {
    this.toaster.error(mesage, '' , {
      positionClass: 'toast-bottom-full-width',
      progressBar: true
    });
  }
  encryptID(id: string): string {
    for (let index = 0; index < 5; index++) {
      id = btoa(id);
    }
    return id;
  }
  decryptID(id: string): string {
    for (let index = 0; index < 5; index++) {
      id = atob(id);
    }
    return id;
  }
}
